import { render, staticRenderFns } from "./AboutApplyfor.vue?vue&type=template&id=d5bd673c&scoped=true&"
import script from "./AboutApplyfor.vue?vue&type=script&lang=js&"
export * from "./AboutApplyfor.vue?vue&type=script&lang=js&"
import style0 from "./AboutApplyfor.vue?vue&type=style&index=0&id=d5bd673c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bd673c",
  null
  
)

export default component.exports